import { createContext, useContext, useState } from 'react'

import { CryptoPaymentModalDataProvider } from './CryptoPaymentModalDataProvider'

import { paymentModes } from './cryptoPaymentConstants'

const CryptoPaymentModalContext = createContext()
CryptoPaymentModalContext.displayName = 'CryptoPaymentModalContext'

export const useCryptoPaymentModal = () => useContext(CryptoPaymentModalContext)

export const CryptoPaymentModalProvider = ({ children }) => {
  const [cryptoPaymentModalMode, setCryptoPaymentModalMode] = useState(null)
  const [cryptoPaymentModalPackageAmount, setCryptoPaymentModalPackageAmount] = useState(null)

  const handleCloseCryptoPaymentModal = () => {
    setCryptoPaymentModalMode(null)
    setCryptoPaymentModalPackageAmount(null)
  }
  const handleOpenCryptoPaymentDepositModal = amount => {
    setCryptoPaymentModalMode(paymentModes.deposit)
    setCryptoPaymentModalPackageAmount(amount)
  }
  const handleOpenCryptoPaymentWithdrawalModal = () => setCryptoPaymentModalMode(paymentModes.withdrawal)

  return (
    <CryptoPaymentModalContext.Provider
      value={{
        cryptoPaymentModalMode,
        cryptoPaymentModalPackageAmount,
        setCryptoPaymentModalPackageAmount,
        handleCloseCryptoPaymentModal,
        handleOpenCryptoPaymentDepositModal,
        handleOpenCryptoPaymentWithdrawalModal
      }}
    >
      {children}
      <CryptoPaymentModalDataProvider
        cryptoPaymentModalMode={cryptoPaymentModalMode}
        setCryptoPaymentModalMode={setCryptoPaymentModalMode}
        handleCloseCryptoPaymentModal={handleCloseCryptoPaymentModal}
      />
    </CryptoPaymentModalContext.Provider>
  )
}
